import React from 'react';
import PropTypes from 'prop-types';

class Select extends React.Component {
  state = {
    selected: '',
  };

  componentDidMount() {
  }
  componentDidUpdate(prevProps) {
    if (prevProps.options !== this.props.options) {
      this.setState({ selected: this.props.options[0].value });
      this.props.onChange(this.props.options[0].id.toString());
    }
  }

  onChange = (e) => {
    this.setState({ selected: e.target.value });
    this.props.onChange(e.target.value.toString());
  }


  render() {
    let string = this.state.selected;

    this.props.options.map((k, v) => {
      if (k.id === this.props.defaultValue && !this.state.selected) {
        string = k.value;
      } else if (this.state.selected.toString() === k.id.toString()) {
        string = k.value;
      }
      return null;
    });

    if (!string && this.props.options.length) {
      this.setState({ selected: this.props.options[0].value });
      string = this.props.options[0].value;
    }

    return (
      <div className="niceselect-wrapper niceselect-default">
        <span className="niceselect-text">{string}</span>
        <select onChange={this.onChange} defaultValue={this.props.defaultValue}>
          {this.props.options.map(v => <option value={v.id} key={v.id}>{v.value}</option>)}
        </select>
      </div>
    );
  }
}

Select.propTypes = {
  onChange: PropTypes.func.isRequired,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  options: PropTypes.array.isRequired,
};

Select.defaultProps = {
  defaultValue: '',
};

export default Select;



// WEBPACK FOOTER //
// ./src/Components/Dashboard/Components/Select.jsx